'use client';

import Script from 'next/script';

const GA_MEASUREMENT_ID = 'G-WRHX72S46N';
const GOOGLE_ADS_ID = 'AW-17570117616';
const CLARITY_ID = 'p42ru6l7pq';

// Google Ads Conversion Labels
export const GOOGLE_ADS_CONVERSIONS = {
  SUBMIT_LEAD_FORM: 'AW-17570117616/qPo9CJ-Uu94bEPDvirpB',
  // Ads UI names this action "About Us", but it is configured to fire on /patient/programs.
  PATIENT_PROGRAMS_PAGE_VIEW: 'AW-17570117616/MyvnCIms_M8bEPDvirpB',
} as const;

export default function GoogleAnalytics() {
  // Avoid loading analytics during local development/testing to keep perf runs clean.
  if (process.env.NODE_ENV !== 'production') return null;

  return (
    <>
      {/* Stub dataLayer/gtag first so later scripts and event code never race */}
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GA_MEASUREMENT_ID}');
            gtag('config', '${GOOGLE_ADS_ID}');
          `,
        }}
      />
      {/* Google Analytics — afterInteractive so it cannot run before the stub above */}
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
      />
      {/* Google Ads */}
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`}
      />
      <Script
        id="microsoft-clarity"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "${CLARITY_ID}");
          `,
        }}
      />
    </>
  );
}
